import useStyles from "../styles";
import { Grid } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import Button from "../../../components/Button/Button";

const RenumerationDetails = () => {
  const classes = useStyles();

  return (
    <div>
      <Grid container spacing={4}>
        <Grid item lg={3} md={4} sm={12} xs={12}>
          <div className="left-container">
            <h4>Financial Information</h4>
            <h6>See your personal Banking Information</h6>
          </div>
        </Grid>
        <Grid item lg={9} md={8} sm={12} xs={12}>
          <div className="right-container">
            <Grid container spacing={2} className={classes.profileform}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup inputType="text" label="Bank Name" name="" />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup inputType="text" label="Account Number" name="" />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup inputType="text" label="Account Name" name="" />
              </Grid>
            </Grid>
            <div className={classes.btnspace}>
              <Button variant="primary" color="btndefault" buttonSize="medium" buttonName="Save Changes" />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default RenumerationDetails;
